<span class="status" [ngStyle]="{ background }"></span>